export default __webpack_public_path__ + "static/lysicrates-james-martin-banner-image-c5a5782822026cd976f41a505b09cb60.png";